import { COLORS } from "assets";

export const fieldSx = { height: 48, minHeight: 48 };
export const iconSx = { fontSize: 20, color: COLORS.surface.secondaryText };

export const dateFieldSx = {
  "& .MuiInputBase-root": {
    bgcolor: COLORS.surface.card,
    color: COLORS.surface.primaryText,
    height: 48,
    borderRadius: `${COLORS.radius.md}px`,
    fontSize: "0.875rem"
  },
  "& .MuiInputBase-input": {
    color: COLORS.surface.primaryText,
    WebkitTextFillColor: COLORS.surface.primaryText,
    colorScheme: "light",
    py: 0
  },
  "& .MuiInputLabel-root": {
    color: COLORS.surface.secondaryText,
    fontSize: "0.875rem",
    fontWeight: 500
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: COLORS.primary
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: COLORS.surface.border
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: COLORS.surface.secondaryText
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: COLORS.primary,
    borderWidth: 1
  },
  "& .MuiFormHelperText-root": {
    color: COLORS.surface.secondaryText,
    mx: 0.5
  },
  "& .MuiFormHelperText-root.Mui-error": {
    color: COLORS.error
  }
};
